import { render, staticRenderFns } from "./PersonaNotasView.vue?vue&type=template&id=39ae4e2a&scoped=true"
import script from "./PersonaNotasView.vue?vue&type=script&lang=js"
export * from "./PersonaNotasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae4e2a",
  null
  
)

export default component.exports